/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { ApplicationView } from '@gh/builder-shared-data';
import { verifyEntity, verifyRoutePermissionOnly } from '@gh/common-shared';
import { Enum } from '@gh/core-data';
import { arrayify } from '@gh/core-util';
import { isEmpty } from 'lodash';
import { BuilderUserContext } from '../user';

export const builderAuthGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean => {
  const router = inject(Router);
  const userContext = inject(BuilderUserContext);

  const applicationView = arrayify(route.data['applicationView']);
  const isAppViewAllowed = isEmpty(applicationView) || verifyEntity(
    applicationView,
    (av) => Enum.exists(ApplicationView, av) && userContext.applicationView === av);

  if (!isAppViewAllowed) {
    return false;
  }

  if (userContext.applicationView === ApplicationView.Office) {
    const canNavigate = verifyRoutePermissionOnly(route, userContext);
    if (!canNavigate) {
      router.navigateByUrl('/404');
      return false;
    }
  }

  return true;
};
